type CalendarAppointment = {
  id: number | string;
  startTime: Date | string;
  endTime?: Date | string | null;
  serviceName?: string | null;
  professionalName?: string | null;
};

const calendarDate = (value: Date | string) => new Date(value).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
const escapeText = (value: string) => value.replace(/\\/g, "\\\\").replace(/,/g, "\\,").replace(/;/g, "\\;").replace(/\n/g, "\\n");

export function buildClientAppointmentCalendar(appointment: CalendarAppointment) {
  const startsAt = new Date(appointment.startTime);
  const endsAt = appointment.endTime ? new Date(appointment.endTime) : new Date(startsAt.getTime() + 60 * 60 * 1000);
  const title = appointment.serviceName ?? "Atendimento Beleza & Bronze";
  const professional = appointment.professionalName ? ` com ${appointment.professionalName}` : "";

  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Beleza e Bronze//Portal da Cliente//PT-BR",
    "BEGIN:VEVENT",
    `UID:belezaebronze-${appointment.id}@portal`,
    `DTSTAMP:${calendarDate(new Date())}`,
    `DTSTART:${calendarDate(startsAt)}`,
    `DTEND:${calendarDate(endsAt)}`,
    `SUMMARY:${escapeText(title)}`,
    `DESCRIPTION:${escapeText(`Atendimento${professional}. Consulte o Portal da Cliente para alterações.`)}`,
    "END:VEVENT",
    "END:VCALENDAR",
    "",
  ].join("\r\n");
}
